<div class="control">
    <button class="btn btn-primary btn-sm" (click)="generatePassword()">{{ label }}</button>
</div>
